import { render, staticRenderFns } from "./Importar_Aceite.vue?vue&type=template&id=c0ca21a2&"
import script from "./Importar_Aceite.vue?vue&type=script&lang=js&"
export * from "./Importar_Aceite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports